import { defaultLocale, localeOptions } from "../../constants/defaultValues";
import { academicModes } from "../../constants/higherEdConstants";

import { CHANGE_LOCALE, CHANGE_ACADEMIC_MODE, CHANGE_VIEW_SEMESTER } from "../actions";

const INIT_STATE = {
  locale:
    localStorage.getItem("currentLanguage") &&
    localeOptions.filter(
      (x) => x.id === localStorage.getItem("currentLanguage"),
    ).length > 0
      ? localStorage.getItem("currentLanguage")
      : defaultLocale,
  academicMode: localStorage.getItem("academicMode") || academicModes.BED,
  // Per-user semester view preference (session-only — resets on new session so
  // users always start from the school's authoritative currentSemester).
  viewSemester: sessionStorage.getItem("viewSemester") || null,
};

const settingsReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case CHANGE_LOCALE:
      return { ...state, locale: action.payload };

    case CHANGE_ACADEMIC_MODE:
      return { ...state, academicMode: action.payload };

    case CHANGE_VIEW_SEMESTER:
      return { ...state, viewSemester: action.payload };

    default:
      return { ...state };
  }
};

export default settingsReducer;
